'use strict';

var getParts = function getParts(value, precision) {
  var cents = void 0,
      isNegative = false;

  if (value < 0) {
    value = Math.abs(value);
    isNegative = true;
  }

  value = value.toString();

  if (precision === 0) {
    cents = '';
  } else if (value.indexOf('.') > 0) {
    // Take everything after the period.
    cents = value.substring(value.indexOf('.') + 1)
    // Then make sure it's no longer than precision specifies.
    .substring(0, precision);

    // Then (in case it's shorter than precision), bring it up to the length
    // precision specifies.
    while (cents.length < precision) {
      cents += '0';
    }
  } else {
    cents = '0'.repeat(precision);
  }

  return {
    whole: Math.floor(value).toString(),
    cents: cents,
    isNegative: isNegative
  };
},
    format = function format(parts, options) {
  var pos = void 0,
      zero = void 0,
      neg = void 0,
      format = void 0,
      value = void 0;

  if (typeof options.format === 'string') {
    pos = zero = neg = options.format;
  } else {
    pos = options.format.pos;
    zero = options.format.zero;
    neg = options.format.neg;
  }

  if (parts.isNegative) {
    format = neg;
  } else if (parts.whole === '0') {
    format = zero;
  } else {
    format = pos;
  }

  value = options.precision === 0 ? parts.whole : parts.whole + options.decimal + parts.cents;

  // If the format doesn't specify a negative sign, prepend it to the value.
  if (parts.isNegative && format.indexOf('-') < 0) {
    value = '-' + value;
  }

  return format.replace(/%s/, options.symbol).replace(/%v/, value);
},
    formats = {
  prefixWithSpace: {
    pos: '%s %v',
    zero: '%s %v',
    neg: '-%s %v'
  },

  prefix: {
    pos: '%s%v',
    zero: '%s%v',
    neg: '-%s%v'
  },

  suffix: '%v%s'
};

// For options with prefixed symbol, both positive and negative formats are
// explicitly provided so that "-" renders before the symbol. For suffixed
// symbols, a single format suffices.

module.exports = {
  tokens: {
    'AED': {
      description: 'United Arab Emirates Dirham',
      symbol: 'AED',
      decimal: '.',
      thousand: ',',
      precision: 2,
      format: formats.prefixWithSpace
    },

    'ARS': {
      description: 'Argentine Peso',
      symbol: '$',
      decimal: ',',
      thousand: '.',
      precision: 2,
      format: formats.prefix
    },

    'AUD': {
      description: 'Australian Dollar',
      symbol: '$',
      decimal: '.',
      thousand: ',',
      precision: 2,
      format: formats.prefix
    },

    'BRL': {
      description: 'Brazilian Real',
      symbol: 'R$',
      decimal: ',',
      thousand: '.',
      precision: 2,
      format: formats.prefix
    },

    'CAD': {
      description: 'Canadian Dollar',
      symbol: 'C$',
      decimal: '.',
      thousand: ',',
      precision: 2,
      format: formats.prefix
    },

    'CHF': {
      description: 'Swiss Franc',
      symbol: 'CHF',
      decimal: '.',
      thousand: '\'',
      precision: 2,
      format: formats.prefix
    },

    'CLP': {
      description: 'Chilean Peso',
      symbol: '$',
      decimal: ',',
      thousand: '.',
      precision: 0,
      format: formats.prefix
    },

    'CNY': {
      description: 'Chinese Yuan',
      symbol: '¥',
      decimal: '.',
      thousand: ',',
      precision: 2,
      format: formats.prefix
    },

    'COP': {
      description: 'Colombian Peso ',
      symbol: '$',
      decimal: ',',
      thousand: '.',
      precision: 0,
      format: formats.prefix
    },

    'CZK': {
      description: 'Czech Republic Koruna',
      symbol: 'Kč',
      decimal: ',',
      thousand: ' ',
      precision: 2,
      format: formats.suffix
    },

    'DKK': {
      description: 'Danish Krone',
      symbol: 'kr',
      decimal: ',',
      thousand: '.',
      precision: 2,
      format: formats.prefix
    },

    'EGP': {
      description: 'Egyptian Pound',
      symbol: '£',
      decimal: '.',
      thousand: ',',
      precision: 2,
      format: formats.prefix
    },

    'EUR': {
      description: 'Euro',
      symbol: '€',
      decimal: '.',
      thousand: ',',
      precision: 2,
      format: formats.prefixWithSpace
    },

    'GBP': {
      description: 'British Pound',
      symbol: '£',
      decimal: '.',
      thousand: ',',
      precision: 2,
      format: formats.prefix
    },

    'HKD': {
      description: 'Hong Kong Dollar',
      symbol: 'HK$',
      decimal: '.',
      thousand: ',',
      precision: 2,
      format: formats.prefix
    },

    'HUF': {
      description: 'Hungary Forint',
      symbol: 'Ft',
      decimal: '.',
      thousand: ' ',
      precision: 0,
      format: formats.suffix
    },

    'IDR': {
      description: 'Indonesian Rupiah',
      symbol: 'Rp',
      decimal: ',',
      thousand: '.',
      precision: 0,
      format: formats.prefix
    },

    'ILS': {
      description: 'Israeli New Shekel',
      symbol: '₪',
      decimal: '.',
      thousand: ',',
      precision: 2,
      format: formats.prefix
    },

    'INR': {
      description: 'Indian Rupee',
      symbol: '₨',
      decimal: '.',
      thousand: ',',
      precision: 2,
      format: formats.prefix
    },

    'JPY': {
      description: 'Japanese Yen',
      symbol: '¥',
      decimal: '.',
      thousand: ',',
      precision: 0,
      format: formats.prefix
    },

    'KRW': {
      description: 'South Korean Won',
      symbol: '₩',
      decimal: '.',
      thousand: ',',
      precision: 0,
      format: formats.suffix
    },

    'MAD': {
      description: 'Moroccan Dirham',
      symbol: '.د.م',
      decimal: '.',
      thousand: ',',
      precision: 2,
      format: formats.prefix
    },

    'MXN': {
      description: 'Mexican Peso',
      symbol: 'MXN',
      decimal: '.',
      thousand: ',',
      precision: 2,
      format: formats.prefix
    },

    'MYR': {
      description: 'Malaysian Ringgit',
      symbol: 'RM',
      decimal: '.',
      thousand: ',',
      precision: 2,
      format: formats.prefix
    },

    'NOK': {
      description: 'Norway Krone',
      symbol: 'kr',
      decimal: ',',
      thousand: ' ',
      precision: 2,
      format: formats.prefix
    },

    'NZD': {
      description: 'New Zealand Dollar',
      symbol: '$',
      decimal: '.',
      thousand: ',',
      precision: 2,
      format: formats.prefix
    },

    'PEN': {
      description: 'Peruvian Nuevo sol',
      symbol: 'S/.',
      decimal: '.',
      thousand: ',',
      precision: 2,
      format: formats.prefix
    },

    'PHP': {
      description: 'Philippine Peso',
      symbol: '₱',
      decimal: '.',
      thousand: ',',
      precision: 2,
      format: formats.prefix
    },

    'PKR': {
      description: 'Pakistan Rupee',
      symbol: '₨',
      decimal: '.',
      thousand: ',',
      precision: 0,
      format: formats.prefix
    },

    'PLN': {
      description: 'Polish Zloty',
      symbol: 'zł',
      decimal: ',',
      thousand: ' ',
      precision: 2,
      format: formats.suffix
    },

    'RON': {
      description: 'Romania Leu',
      symbol: 'lei',
      decimal: ',',
      thousand: ' ',
      precision: 2,
      format: formats.suffix
    },

    'RUB': {
      description: 'Russia Ruble',
      symbol: 'руб',
      decimal: ',',
      thousand: ' ',
      precision: 2,
      format: formats.suffix
    },

    'SAR': {
      description: 'Saudi Arabia Riyal',
      symbol: '﷼',
      decimal: '.',
      thousand: ',',
      precision: 2,
      format: formats.suffix
    },

    'SEK': {
      description: 'Swedish Krona',
      symbol: 'kr',
      decimal: ',',
      thousand: '.',
      precision: 2,
      format: formats.suffix
    },

    'SGD': {
      description: 'Singapore Dollar',
      symbol: '$',
      decimal: '.',
      thousand: ',',
      precision: 2,
      format: formats.prefix
    },

    'THB': {
      description: 'Thai Baht',
      symbol: '฿',
      decimal: '.',
      thousand: ',',
      precision: 2,
      format: formats.prefix
    },

    'TRY': {
      description: 'Turkey Lira',
      symbol: 'TL',
      decimal: ',',
      thousand: '.',
      precision: 2,
      format: formats.suffix
    },

    'TWD': {
      description: 'New Taiwan Dollar',
      symbol: 'NT$',
      decimal: '.',
      thousand: ',',
      precision: 2,
      format: formats.prefix
    },

    'UAH': {
      description: 'Ukrainian Hryvnia',
      symbol: '₴',
      decimal: ',',
      thousand: ' ',
      precision: 2,
      format: formats.suffix
    },

    'USD': {
      description: 'United States Dollar',
      symbol: '$',
      decimal: '.',
      thousand: ',',
      precision: 2,
      format: formats.prefix
    },

    'UYU': {
      description: 'Peso Uruguayo',
      symbol: '$',
      decimal: '.',
      thousand: ',',
      precision: 2,
      format: formats.prefix
    },

    'VND': {
      description: 'Vietnamese Dong',
      symbol: '₫',
      decimal: ',',
      thousand: '.',
      precision: 0,
      format: formats.suffix
    },

    'ZAR': {
      description: 'South Africa Rand',
      symbol: 'R',
      decimal: ',',
      thousand: ' ',
      precision: 2,
      format: formats.prefix
    }
  },

  customFormatters: {
    'INR': function INR(value) {
      var parts = getParts(value, this.precision),
          otherNumbers = parts.whole.substring(0, parts.whole.length - 3);

      var lastThree = parts.whole.substring(parts.whole.length - 3);

      if (otherNumbers !== '') {
        lastThree = ',' + lastThree;
      }

      parts.whole = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, this.thousand) + lastThree;

      return format(parts, this);
    }
  },

  helpers: {
    getParts: getParts,
    format: format
  }
};